import classnames from 'classnames';
import Image, { StaticImageData } from 'next/image';

import styles from './BannerCard.module.scss';

interface BannerCardProps {
  title: string;
  description: string;
  image: StaticImageData;
  imageAlt: string;
  reverseLayout?: boolean;
}

const BannerCard = ({
  title,
  description,
  image,
  imageAlt,
  reverseLayout = false,
}: BannerCardProps) => {
  return (
    <div
      className={classnames(
        `bg-white br16 d-grid c-gap16 ${styles['banner-card']}`,
        {
          [styles['banner-card-reverse']]: reverseLayout,
        }
      )}
    >
      <div className={styles['banner-card-image']}>
        <Image
          src={image}
          alt={imageAlt}
          style={{ objectFit: 'contain' }}
          fill
          sizes="(max-width: 720px) 100vw, 40vw"
        />
      </div>
      <div className={styles['banner-card-text']}>
        <div className="p-h3 p--serif">{title}</div>
        <div
          data-aos="animate-underline"
          data-aos-once="true"
          className={`br8 bg-purple-500 ${styles.separator}`}
        />
        <p className="p-p mt16 tc-grey-600">{description}</p>
      </div>
    </div>
  );
};

export default BannerCard;
